import { useState, useEffect } from 'react'
import { getSharedCompositions } from 'services/compositions'

const useSharedComposition = (uuid, isSaving) => {
    const [sharedCompositionData, setSharedCompositionData] = useState({})
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        setIsLoading(true)
        const fetchData = async () => {
            try {
                if (!uuid) {
                    setError(true)
                } else {
                    const response = await getSharedCompositions(uuid)
                    setSharedCompositionData(response.data)
                    setError(false)
                }

                setIsLoading(false)
            } catch (err) {
                setError(err)
            }
        }
        setIsLoading(false)
        fetchData()
    }, [uuid, isSaving])
    return { isLoading, error, sharedCompositionData }
}

export default useSharedComposition
